import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable } from 'rxjs';
import { PagePermissionsService } from './page-permissions.service';
import { AccountService } from './account.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RessourcePermissionGuard implements CanActivate {

  constructor(
    private pagePermissionsService: PagePermissionsService,
    private accountService: AccountService,
    private router: Router
  ){}

  canActivate(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const action = route.params['action'];
    const requiredAction = action === 'edit' ? 'edit' : 'read';
    const resource = route.data['resource'];

    if (!resource) {
      console.error('PermissionGuard: resource not defined in route data');
      return from([false]);
    }

    return from(this.accountService.identity()).pipe(
      map(user => {
        if (!user) {
          this.router.navigate(['/']);
          return false;
        }
        const hasPermission = this.pagePermissionsService.hasPagePermission(resource, requiredAction, true);
        if (!hasPermission) {
          this.router.navigate(['/h/error/403'], {
            queryParams: {
              attempted: state.url 
            }
          });
          return false;
        }
        return true;
      })
    )
  }
}
